import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Undo = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      stroke={stroke}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/undo">
        <g id="undo">
          <path
            id="Vector"
            d="M10.0872 12.7067H4.75391C4.48057 12.7067 4.25391 12.48 4.25391 12.2067C4.25391 11.9334 4.48057 11.7067 4.75391 11.7067H10.0872C11.6472 11.7067 12.9206 10.4334 12.9206 8.87337C12.9206 7.31337 11.6472 6.04004 10.0872 6.04004H2.75391C2.48057 6.04004 2.25391 5.81337 2.25391 5.54004C2.25391 5.26671 2.48057 5.04004 2.75391 5.04004H10.0872C12.2006 5.04004 13.9206 6.76004 13.9206 8.87337C13.9206 10.9867 12.2006 12.7067 10.0872 12.7067Z"
          />
          <path
            id="Vector_2"
            d="M4.28703 7.70671C4.16036 7.70671 4.0337 7.66004 3.9337 7.56004L2.22703 5.85338C2.0337 5.66004 2.0337 5.34004 2.22703 5.14671L3.9337 3.44004C4.12703 3.24671 4.44703 3.24671 4.64036 3.44004C4.8337 3.63338 4.8337 3.95338 4.64036 4.14671L3.28703 5.50004L4.64036 6.85338C4.8337 7.04671 4.8337 7.36671 4.64036 7.56004C4.54703 7.66004 4.4137 7.70671 4.28703 7.70671Z"
          />
        </g>
      </g>
    </svg>
  );
};

Undo.displayName = 'Undo';
